(() => {
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-ms-outfit-builder]').forEach(form => {
      form.dataset.pending = 'false';
      const button = form.querySelector('[type="submit"]');
      button.disabled = false;
      if (button.dataset.idleLabel) button.textContent = button.dataset.idleLabel;
    });
  });
  document.addEventListener('change', event => {
    const form = event.target.closest('[data-ms-outfit-builder]');
    if (!form) return;
    form.querySelector('[data-ms-outfit-status]').textContent = '';

  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-ms-outfit-builder]')) return;
    event.preventDefault();
    if (form.dataset.pending === 'true') return;
    const status = form.querySelector('[data-ms-outfit-status]');
    const rows = [...form.querySelectorAll('[data-ms-outfit-piece]')].filter(row => row.querySelector('[data-ms-piece-include]').checked);
    if (!rows.length) { status.textContent = form.dataset.select; return; }
    const missing = rows.find(row => !row.querySelector('[data-ms-piece-variant]').value);
    if (missing) { status.textContent = form.dataset.choose; missing.querySelector('[data-ms-piece-variant]').focus(); return; }
    const section = form.closest('.shopify-section');
    const primary = [...(section || document).querySelectorAll('form[data-product-form]')].find(candidate => candidate.dataset.productHandle === form.dataset.primaryHandle);
    const primaryId = primary?.querySelector('[name="id"]')?.value;
    const primaryButton = primary?.querySelector('[data-add-to-cart]');
    if (!primaryId || !primaryButton || primaryButton.disabled || primaryButton.getAttribute('aria-disabled') === 'true') {
      status.textContent = form.dataset.primaryError;
      primary?.querySelector('[name="id"]')?.focus();
      return;
    }
    const quantity = Math.max(1, Number(primary.querySelector('[name="quantity"]')?.value) || 1);
    const items = [{ id: primaryId, quantity }];
    rows.forEach(row => items.push({ id: row.querySelector('[data-ms-piece-variant]').value, quantity: 1 }));
    const properties = {};
    new FormData(primary).forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string') properties[match[1]] = value;
    });
    if (Object.keys(properties).length) items[0].properties = properties;
    const sellingPlan = primary.querySelector('[name="selling_plan"]')?.value;
    if (sellingPlan) items[0].selling_plan = sellingPlan;
    const button = form.querySelector('[type="submit"]');
    const label = button.textContent;
    form.dataset.pending = 'true';
    button.disabled = true;
    button.dataset.idleLabel = label;
    button.textContent = form.dataset.adding;
    status.textContent = '';
    try {
      const response = await fetch(form.action + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || form.dataset.error);
      window.location.assign(form.dataset.cartUrl);
    } catch (error) {
      status.textContent = error.message || form.dataset.error;
      button.disabled = false;
      button.textContent = label;
      form.dataset.pending = 'false';
    }
  });
})();